import React, { useState, forwardRef,useEffect , useImperativeHandle, useRef} from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Modal } from 'react-bootstrap';

const CreateVehicleRepairRecord  = forwardRef((props, ref) => {
  const [formData, setFormData] = useState({
    RepairOrderID:props.data.RepairOrderID,
    VehicleID: props.data.VehicleID,
    CustomerID:  props.data.CustomerID,
    RepairDate: props.data.RepairDate,
   // RepairStatus: '',
   // TechnicianID: '',
   // LaborHours: '',
   // ServiceCost: '',
   // Notes: '',
   // PartQuantities: '',
   // PartCost: '',
  });
  console.log('formData',formData)
  const [inviteModal, setInviteModal] = useState(false);
  useImperativeHandle(ref, () => ({
    showInviteModal() {
      setInviteModal(true);
    }
  }));
  
  const [customers, setCustomers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  const [services, setServices] = useState([]);
  const [parts, setParts] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedParts, setSelectedParts] = useState([]);
  const [errors, setErrors] = useState(null);
  
  const fetchCategories = async () => {
    try {
        const response = await axios.get('https://subk.education.com.ly/back/api/getServiceCategory'); // Adjust to your actual API URL
        setCategories(response.data);
    } catch (error) {
        console.error('Error fetching categories:', error);
    }
};
  useEffect(() => {
      fetchCategories();

  }, []);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  

  

const handleSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission
  
  console.log('Selected Services:', selectedService);
 
  // Check if selectedServices and selectedParts are non-empty arrays
  if (!selectedService || selectedService.length === 0) {
      console.error('لم يتم اختيار اي خدمة');
  }
  
  

  // Prepare repair order data
  const repairOrderData = {
    repairDetails: [
          
          // Add selected services to repairDetails
          ...selectedService.map(service => ({
            RepairOrderID:formData.RepairOrderID,
              ServiceID: service.ServiceID,
              TechnicianID: formData.TechnicianID, // Assuming this field is selected in your form
              LaborHours: formData.LaborHours,     // Assuming this field is from your form
              ServiceCost: service.StandardPrice,    // Assuming service cost is part of each service object
          }))
    ]
  };

  // Log the full repairOrderData for debugging purposes
  console.log('Repair Order Data to be Sent:', repairOrderData);

  try {
      // Send the complete data to the API
      const response = await fetch('https://subk.education.com.ly/back/api/repairdetails', {
          method: 'post',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(repairOrderData), // Send the repairOrderData
      });

      const result = await response.json();
      props.fetchRepairOrder();
      setInviteModal(false);
      if (response.ok) {
        toast.success('تم  الاضافة بنجاح!');
        props.fetchRepairOrder();
          setInviteModal(false);
setSelectedService([])
      } else {
          console.error('Error saving repair order:', result.message);
      }
  } catch (error) {
      console.error('Error:', error);
  }
};

 
 
  const [categories, setCategories] = useState([]);
   const [selectedCategory, setSelectedCategory] = useState(null);
  
   
  
  const [selectedService, setSelectedService] = useState([]); // New state for selected service
  const [expandedCategoryId, setExpandedCategoryId] = useState(null); // Track which category is expanded
  
  const handleCategoryChange = async (category) => {
    const categoryId = category.servicecategoryID;

    // If the clicked category is already expanded, close it
    if (expandedCategoryId === categoryId) {
        setExpandedCategoryId(null);
        setServices([]); // Clear services if category is collapsed\
       // setSelectedService([]); // Reset selected service when collapsing
    } else {
        setExpandedCategoryId(categoryId);
        // Fetch services related to the selected category
        try {
            const response = await axios.get(`https://subk.education.com.ly/back/api/ServiceCategory/${categoryId}`); // Adjust your API endpoint accordingly
            setServices(response.data); // Assuming the API returns an array of services
        } catch (error) {
            console.error('Error fetching services:', error);
        }
    } 
   
};
const handleServiceSelect = (service) => {
  setSelectedService((prevSelectedService) => {
      // Check if the service is already selected
      const isSelected = prevSelectedService.some(selected => selected.ServiceID === service.ServiceID);
      
      if (isSelected) {
          // Remove the service from selected services
          return prevSelectedService.filter(selected => selected.ServiceID !== service.ServiceID);
      } else {
          // Add the service to selected services
          return [...prevSelectedService, service];
      }
  });
  console.log(selectedService)

};
//-------------------------part---------------------------
 
    // Handle part class selection
    
    // Handle part selection (checkboxes)
    
    // Initial state for selected parts with quantity

// Handle part selection
 

 
// Get the quantity of a selected part
 

  return (
    <>
            <ToastContainer />

   
    <Modal show={inviteModal}  style={{width:'750px', marginLeft:"200px"}} size="xl" centered>
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5">اضافة خدمات</h1>
          <button type="button" className="btn-close " style={{marginLeft: 0 }}  padding="" onClick={()=>setInviteModal(false)}></button>
          </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {errors && <div className="alert alert-danger">{errors}</div>}
           
                    <div className="row">
                    <div className="col-xl-6">

            <h6>تصنيفات الخدمات</h6>
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {categories.map(category => (
                    <div key={category.servicecategoryID}>
                        <div
                            onClick={() => handleCategoryChange(category)}
                            style={{ 
                                cursor: 'pointer', 
                                margin: '10px 0', 
                                padding: '10px', 
                                border: '1px solid #ccc', 
                               // background: expandedCategoryId === category.servicecategoryID ? 'rgb(37, 50, 78);' :' rgb(24, 34, 55)'// Highlight if expanded
                            }}
                        >
                            {category.categoryName}
                        </div>
                        {/* Render services only if the category is expanded */}
                        {expandedCategoryId === category.servicecategoryID && services.length > 0 && (
                            <div style={{ padding: '10px', border: '1px solid #ccc', marginBottom: '10px' ,backgroundColor:' #1c4c49'}}>
                                {services.map(service => (
                                    <div 
                                        key={service.ServiceID} 
                                        className="service-details" 
                                        style={{ 
                                            margin: '5px 0', 
                                            cursor: 'pointer', 
                                            background: selectedService.some(selected => selected.ServiceID === service.ServiceID) ? '#d1e7dd' : '#fff', // Highlight selected service
                                            padding: '5px', 
                                            border: '1px solid #ccc' 
                                        }}
                                    >
                                        <input 
                                            type="checkbox" 
                                            checked={selectedService.some(selected => selected.ServiceID === service.ServiceID)} 
                                            onChange={() => handleServiceSelect(service)} 
                                        />
                                        <strong style={{ marginLeft: '5px' }}>{service.ServiceName}</strong>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
         
                </div>
                <div className="col-xl-6">
                {selectedService.length > 0 && (
                <div style={{ marginTop: '20px', padding: '10px', border: '1px solid #ccc' }}>
                    <h4>الخدمات المختارة:</h4>
                    {selectedService.map(service => (
                        <div key={service.ServiceID}>
                            <strong>{service.ServiceName}</strong>
                        </div>
                    ))}
                </div>
            )}
            {expandedCategoryId && services.length === 0 && (
                <p>لا توجد خدمات لهدا التصنيف</p>
            )}
                </div>

        </div>

 </div>

          <div className="modal-footer">
            <button type="submit" className="btn btn-primary">حفظ</button>
           </div>
        </form>
      </div>
      <ToastContainer />
    </Modal> </>
 );
});

export default CreateVehicleRepairRecord;
